import { Component } from '@angular/core';
import { Client } from './clients.model';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { Message } from 'primeng/primeng';
import { ClientsService } from '../../../services/clients/clients.service';
import { Globals } from '../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';
import { SuperClass } from '../../../superclass/SuperClass';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css'],
})
export class ClientsComponent extends SuperClass {
  defaultQueryWindows;
  selectedRow: Client;
  newClient: Client;
  newClientForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;
  clients: Client[];

  msgs: Message[] = [];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Admin' },
      {
        label: 'Clients',
        routerLink: [{ outlets: { sub: [RouterConst.ADMIN_CLIENTS] } }],
      },
    ]);
    this.newClient = new Client();
  }

  reloadData() {
    this.http_getTimeWindows((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.defaultQueryWindows = data.payload;
      }
    });
    this.http_getAllClients((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.clients = data.payload;
        this.setQueryWindowDescription();
      }
    });

    this.selectedRowForm = this.fb.group({
      clientName: new FormControl('', Validators.required),
      clientCode: new FormControl('', Validators.required),
      default: new FormControl('', Validators.required),
    });

    this.newClientForm = this.fb.group({
      clientName: new FormControl('', Validators.required),
      clientCode: new FormControl('', Validators.required),
      default: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new Client(e.data);
    this.selectedRow.defaultQueryWindow = this.defaultQueryWindows.filter(
      el => {
        return el.description === this.selectedRow.defaultQueryWindow;
      },
    )[0];
  }

  addNewClient() {
    this.unselectRow();
    this.display = true;
  }

  deleteClient() {
    this.http_deleteClients({ id: this.selectedRow.id }, (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.clients = data.payload;
        this.setQueryWindowDescription();
        this.showSuccessMessage('New Client has been updated');
        this.unselectRow();
      }
    });
  }

  createNewClient() {
    const client = new Client(this.newClient);
    // const requiredFields = [
    //   {id: 'client_name', value: client.clientName, fieldName: 'Client Name'},
    //   {id: 'client_code', value: client.clientCode, fieldName: 'Client Code'},
    //   {id: 'client_def_query_window', value: client.defaultQueryWindow, fieldName: 'Default Query Window'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.queryWindow(client);
    this.http_addClients(client, (data: any) => {
      this.clients = data.payload;
      this.setQueryWindowDescription();
      this.showSuccessMessage('New Client has been created');
      this.display = false;
    });
  }

  queryWindow(selected) {
    for (let i = 0; i < this.defaultQueryWindows.length; i++) {
      if (
        selected.defaultQueryWindow.timeWindow ===
        this.defaultQueryWindows[i].timeWindow
      ) {
        selected.defaultQueryWindow = this.defaultQueryWindows[i].timeWindow;
      }
    }
    return selected;
  }

  saveChanges() {
    const client = new Client(this.selectedRow);
    // const requiredFields = [
    //   {id: 'client_name', value: client.clientName, fieldName: 'Client Name'},
    //   {id: 'client_code', value: client.clientCode, fieldName: 'Client Code'},
    //   {id: 'client_def_query_window', value: client.defaultQueryWindow, fieldName: 'Default Query Window'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.queryWindow(client);
    this.http_updateClients(client, (data: any) => {
      this.clients = data.payload;
      this.setQueryWindowDescription();
      this.unselectRow();
      this.showSuccessMessage('New Client has been updated');
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  setQueryWindowDescription() {
    for (let i = 0; i < this.clients.length; i++) {
      for (let j = 0; j < this.defaultQueryWindows.length; j++) {
        if (
          this.clients[i].defaultQueryWindow ===
          this.defaultQueryWindows[j].timeWindow
        ) {
          this.clients[i].defaultQueryWindow = this.defaultQueryWindows[
            j
          ].description;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/admin/clients/clients.component.ts